import React, { FunctionComponent, Dispatch, SetStateAction, useState, useMemo } from 'react'
import useStore, { WizardLocationByIdSelector, WizardQuestionsSelector, WizardIntegrationsSelector } from '___store'

import { SegmentsLocation, TextLocation } from '___types'
import { Button } from 'components/CasusComponents'
import { classes } from '../..'
import { Computed, Integrations, Questions, Replacement, Languages, Splits, Instancing } from './Connect.Components'
import MarkerAssign from './MarkerAssign'

type UseStoreHookResultType = {
  wizardLocationById: WizardLocationByIdSelector
  wizardQuestions: WizardQuestionsSelector
  wizardIntegrations: WizardIntegrationsSelector
  currentConfiguringQuestion: any
}

type Tab = 'replacement' | 'show-hide' | 'instancing'
type Props = { id: string }
export const Connect: FunctionComponent<Props> = React.memo(({ id }) => {
  const {
    wizardLocationById,
    wizardQuestions,
    wizardIntegrations,
    currentConfiguringQuestion: { id: currentQuestionId } = {},
  } = useStore(
    `selectWizardLocationById[${id}]`,
    'selectWizardQuestions',
    'selectWizardIntegrations',
    'selectCurrentConfiguringQuestion' // TEMPORARY
  ) as UseStoreHookResultType

  const [tab, setTab]: [Tab, Dispatch<SetStateAction<Tab>>] = useState('replacement' as Tab)

  const { valueSources, conditionals } = (wizardLocationById || {}) as TextLocation | SegmentsLocation

  const optionConnectRender = useMemo(() => {
    //@ts-ignore
    return <MarkerAssign markerId={id} currentQuestionId={currentQuestionId} />
  }, [id, currentQuestionId]) // TEMPORARY

  return (
    <div className={classes.configEntry.markerConfiguration.fragment.wrapper}>
      <span className={classes.configEntry.markerConfiguration.fragment.title}>Connect Marker</span>
      <span className={classes.configEntry.markerConfiguration.fragment.text}>Connect this marker to one or more value sources.</span>
      <div className={classes.configEntry.markerConfiguration.fragment.connect.tabs.wrapper}>
        <div className={classes.configEntry.markerConfiguration.fragment.connect.tabs.header}>
          <Button onClick={() => setTab('replacement')} dataSet={{ active: tab === 'replacement' ? '' : undefined }}>
            Replacement
          </Button>
          <Button onClick={() => setTab('show-hide')} dataSet={{ active: tab === 'show-hide' ? '' : undefined }}>
            Show or Hide
          </Button>
          <Button onClick={() => setTab('instancing')} dataSet={{ active: tab === 'instancing' ? '' : undefined }}>
            Cloning
          </Button>
        </div>
        {tab === 'replacement' ? (
          <div className={classes.configEntry.markerConfiguration.fragment.connect.tabs.content}>
            <Replacement id={id} valueSources={valueSources} questions={wizardQuestions} externals={wizardIntegrations} />
            <Questions id={id} valueSources={valueSources} />
            <Integrations id={id} valueSources={valueSources} />
            <Computed id={id} valueSources={valueSources} />
          </div>
        ) : null}
        {tab === 'show-hide' ? (
          <div className={classes.configEntry.markerConfiguration.fragment.connect.tabs.content}>
            {optionConnectRender}
            <Languages id={id} conditionals={conditionals} />
            <Splits id={id} conditionals={conditionals} />
          </div>
        ) : null}
        {tab === 'instancing' ? (
          <div className={classes.configEntry.markerConfiguration.fragment.connect.tabs.content}>
            <Instancing id={id} />
          </div>
        ) : null}
      </div>
    </div>
  )
})

Connect.displayName = 'Wizard-Configuration-MarkerConfiguration-Connect'

export default Connect
